import React, { useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { MessageCircle, Send } from "lucide-react";

const WHATSAPP = "https://wa.me/917250120666";

export default function LeadForm({ service, type = "service", title = "Contact Sales", testIdPrefix = "lead" }) {
  const [form, setForm] = useState({ name: "", email: "", phone: "", company: "", message: "" });
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await api.post("/leads", { ...form, service, type, source: "web" });
      toast.success("Thanks! Our team will WhatsApp you.");
      window.open(`${WHATSAPP}?text=${encodeURIComponent(`Hi Eventom! I'm ${form.name}, interested in ${service}. Phone: ${form.phone}.`)}`, "_blank");
      setForm({ name: "", email: "", phone: "", company: "", message: "" });
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Could not submit — try WhatsApp direct.");
    } finally { setSubmitting(false); }
  };

  return (
    <div data-testid={`${testIdPrefix}-form-wrap`} className="glass rounded-3xl p-8">
      <div className="inline-flex rounded-full bg-lime text-bg px-3 py-1 font-mono text-[10px] tracking-widest uppercase mb-4">{title}</div>
      <h3 className="font-display text-3xl md:text-4xl uppercase leading-tight mb-6">Let’s talk <span className="grad-text-hot">{service}</span>.</h3>
      <form onSubmit={submit} className="grid gap-3">
        <input data-testid={`${testIdPrefix}-name`} required placeholder="Your name" className="input-dark" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
        <div className="grid sm:grid-cols-2 gap-3">
          <input data-testid={`${testIdPrefix}-phone`} required placeholder="Phone / WhatsApp" className="input-dark" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} />
          <input data-testid={`${testIdPrefix}-email`} placeholder="Email (optional)" className="input-dark" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
        </div>
        <input data-testid={`${testIdPrefix}-company`} placeholder="Organisation / College / Brand" className="input-dark" value={form.company} onChange={(e) => setForm({ ...form, company: e.target.value })} />
        <textarea data-testid={`${testIdPrefix}-message`} rows={3} placeholder="Tell us what you need" className="input-dark resize-none" value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} />
        <div className="flex flex-wrap gap-3 mt-2">
          <button data-testid={`${testIdPrefix}-submit`} disabled={submitting} type="submit" className="btn-primary">
            <Send className="w-4 h-4" /> {submitting ? "Sending..." : "Send Request"}
          </button>
          <a data-testid={`${testIdPrefix}-whatsapp`} href={`${WHATSAPP}?text=${encodeURIComponent(`Hi Eventom! Interested in ${service}.`)}`} target="_blank" rel="noreferrer" className="btn-lime">
            <MessageCircle className="w-4 h-4" /> WhatsApp Direct
          </a>
        </div>
      </form>
    </div>
  );
}
